import Axios from '@/services/axios'
import msg from '@/common/msg'
import * as code from '@/common/code'

export default {
  getMaintenanceMode () {
    return new Promise((resolve, reject) => {
      Axios.get(
        'Warehouse/sc/maintenance',
        {},
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getDescriptions () {
    return new Promise((resolve, reject) => {
      Axios.get(
        '/Warehouse/sc/descriptions',
        {},
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getInventory () {
    return new Promise((resolve, reject) => {
      Axios.get(
        '/Warehouse/sc/inventory',
        {},
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  downloadProductCSV (params = {}, fileName = 'download.csv') {
    return new Promise((resolve, reject) => {
      Axios.downloadShiftJis(
        '/Warehouse/sc/inventory/export-csv',
        params,
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        },
        fileName
      )
    })
  },
  getMonths (params = {}) {
    return new Promise((resolve, reject) => {
      Axios.get(
        'Warehouse/sc/inventory/months',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  downloadInventoryEndOfMonthCSV (params = {}, fileName = 'download.csv') {
    return new Promise((resolve, reject) => {
      Axios.downloadShiftJis(
        '/Warehouse/sc/inventory/months/export-csv',
        params,
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        },
        fileName
      )
    })
  },
  exportShippingCost (params = {}, fileName = 'download.csv') {
    return new Promise((resolve, reject) => {
      Axios.downloadShiftJis(
        '/Warehouse/sc/expense/shipping-cost/export-csv',
        params,
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        },
        fileName
      )
    })
  },
  exportOtherCost (params = {}, fileName = 'download.csv') {
    return new Promise((resolve, reject) => {
      Axios.downloadShiftJis(
        '/Warehouse/sc/expense/other-cost/export-csv',
        params,
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        },
        fileName
      )
    })
  },
  getShippingMultichannelInfo () {
    return new Promise((resolve, reject) => {
      Axios.get(
        'Warehouse/sc/shipping/multichannel/from-info',
        {},
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  registerShippingMultichannelInfo (params) {
    return new Promise((resolve, reject) => {
      Axios.post(
        'Warehouse/sc/shipping/multichannel/from-info',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  updateShippingMultichannelInfo (params) {
    return new Promise((resolve, reject) => {
      Axios.put(
        'Warehouse/sc/shipping/multichannel/from-info',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  setDefaultShippingMultichannelInfo (params) {
    return new Promise((resolve, reject) => {
      Axios.post(
        'Warehouse/sc/shipping/multichannel/from-info-default',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  deleteShippingMultichannelInfo (params) {
    return new Promise((resolve, reject) => {
      Axios.del(
        'Warehouse/sc/shipping/multichannel/from-info',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getStorageSize (params) {
    return new Promise((resolve, reject) => {
      Axios.post(
        'Warehouse/sc/shipping/update-storage-size',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getShippingStockInfo (params) {
    return new Promise((resolve, reject) => {
      Axios.post(
        'Warehouse/sc/shipping/get-stock-info',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  registerShippingMultichannel (params) {
    return new Promise((resolve, reject) => {
      Axios.post(
        'Warehouse/sc/shipping/multichannel',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getShippingMultiDetail (params) {
    return new Promise((resolve, reject) => {
      Axios.get(
        'Warehouse/sc/shipping/multichannel',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  deleteShippingMultichannel (params) {
    return new Promise((resolve, reject) => {
      Axios.del(
        'Warehouse/sc/shipping/multichannel',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getShippingMultichannelStatus (params) {
    return new Promise((resolve, reject) => {
      Axios.get(
        'Warehouse/sc/shipping/multichannel/shipping-status',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getShippingList (params) {
    return new Promise((resolve, reject) => {
      Axios.get(
        'Warehouse/sc/shipping-list',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/warehousescservice.js